import BigNumber from 'bignumber.js'
import { useCallback } from 'react'
import { mintNexItem } from 'utils/calls'
import { useNexItemsContract } from 'hooks/useContract'
import { TransactionResponse } from '@ethersproject/providers'
import { TransactionReceipt } from '@ethersproject/abstract-provider/src.ts/index'

const useMintNexItem = (
  nexItemId: string,
  price: string,
  amount: string,
  walletAddress: string
) => {
  const nexItemsContract = useNexItemsContract()

  const handleMint = useCallback(
    async (
      onTransactionSubmitted: (tx: TransactionResponse) => void,
      onSuccess: (receipt: TransactionReceipt) => void,
      onError: (receipt: TransactionReceipt) => void,
    ) => {
      const tx = await mintNexItem(
        nexItemsContract,
        walletAddress,
        nexItemId,
        price,
        amount
      )
      onTransactionSubmitted(tx)
      const receipt = await tx.wait()
      if (receipt.status) {
        onSuccess(receipt)
      } else {
        onError(receipt)
      }
    },
    [amount, nexItemsContract],
  )

  return { onMint: handleMint }
}

export default useMintNexItem
